import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./recentlyViewed.module.css";
import { LeftArrow, RightArrow } from "../../../../Svg";
import { useNavigate } from "react-router-dom";
import { useCurrency } from '../../../context/CurrencyContext';
import RecentlyViewedProductImage from "../../../components/RecentlyViewed/RecentlyViewedProductImage";
import {
  RECENTLY_VIEWED_PRODUCTS_CHANGED_EVENT,
  RECENTLY_VIEWED_PRODUCTS_KEY,
  readRecentlyViewedProducts
} from "../../../../utils/recentlyViewedProducts";

const products = [
  {
    id: 1,
    name: "Ribbon Twist Gold Necklace",
    price: "₹27,200",
    originalPrice: "₹35,000",
    image: "/assets/pain2.png",
  },
  {
    id: 2,
    name: "Emerald Gold Necklace",
    price: "₹29,500",
    originalPrice: "₹40,000",
    image: "/assets/pain3.png",
  },
  {
    id: 3,
    name: "Royal Gold Necklace",
    price: "₹50,000",
    originalPrice: "₹65,000",
    image: "/assets/pain4.png",
  },
  {
    id: 4,
    name: "Elegant Pearl Necklace",
    price: "₹18,000",
    originalPrice: "₹25,000",
    image: "/assets/pain5.png",
  },
];

const CustomArrow = ({ className, onClick, arrowDirection }) => {
  return (
    <div
      className={`${className} ${styles.customArrow} ${arrowDirection === "left" ? styles.leftArrow : styles.rightArrow
        }`}
      onClick={onClick}
    >
      {arrowDirection === "left" ? <LeftArrow /> : <RightArrow />}
    </div>
  );
};

const RecentlyViewed = () => {
  const navigate = useNavigate();
  const [recentlyViewed, setRecentlyViewed] = useState(() => readRecentlyViewedProducts());
  const { formatPrice } = useCurrency();

  // console.log('recentlyViewed', recentlyViewed);

  // Fetch recently viewed products from local storage
  useEffect(() => {
    const fetchRecentlyViewed = () => {
      setRecentlyViewed(readRecentlyViewedProducts());
    };

    const handleStorage = (event) => {
      if (!event.key || event.key === RECENTLY_VIEWED_PRODUCTS_KEY) {
        fetchRecentlyViewed();
      }
    };

    // Fetch data on mount
    fetchRecentlyViewed();

    // Listen for changes in localStorage
    window.addEventListener("storage", handleStorage);
    window.addEventListener(RECENTLY_VIEWED_PRODUCTS_CHANGED_EVENT, fetchRecentlyViewed);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener(RECENTLY_VIEWED_PRODUCTS_CHANGED_EVENT, fetchRecentlyViewed);
    };
  }, []);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <CustomArrow arrowDirection="left" />,
    nextArrow: <CustomArrow arrowDirection="right" />,
    adaptiveHeight: true,
    autoplay: true, // Enable auto-play
    autoplaySpeed: 200000, // Set auto-play speed in milliseconds (3 seconds)
    pauseOnHover: true, // Pause auto-play on hover
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 468,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ],
  };

  if (!recentlyViewed?.length) {
    return null;
  }

  return (
    <div className={styles.sliderContainer}>
      <div className={styles.slidermain}>
        {/* Title Section */}
        <div className={styles.sliderheading}>
          <h4 className={styles.title}>Your choice</h4>
          <h2 className={styles.subtitle}>Recently Viewed Products</h2>
        </div>

        {/* Slider Section */}
        <div className={styles.sliderCards}>
          <Slider {...settings} className={styles.slickSlider}>
            {recentlyViewed.map((product) => (
              <div key={product.id} className={styles.productCard} onClick={() => {
                navigate(`/prodDescription/${product?.id}`);
                window.scrollTo(0, 0);
              }}
                style={{ cursor: 'pointer' }}
              >
                {/* <div className={styles.imagecover}> */}
                <RecentlyViewedProductImage
                  src={product.image}
                  alt={product.name}
                  style={{ cursor: 'pointer' }}
                />
                {/*  </div> */}
                {/* <p className={styles.productName}>{product.name}</p> */}
                <p className={styles.productName}>{product.name && product.name?.length > 15 ? `${product.name?.substring(0, 15)}...` : product.name}</p>
                <p className={styles.price}>
                  <span className={styles.currentPrice}>{formatPrice(product.sellingPrice)}</span>
                  {/* {product?.discount}
                    <span className={styles.originalPrice}>
                    {formatPrice(product.totalPrice)}
                    </span> */}
                </p>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default RecentlyViewed;
